import { z } from 'zod';
// EW-65. A token may resolve to more than one role, so callers work with AdminRole[].
export const AdminRoleSchema = z.enum(['ADMIN', 'AI_ADMIN', 'AUDITOR']);
//# sourceMappingURL=admin-role.js.map